import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProductOP, ProductsResponseOP } from '@cemex-core/cmx-api';
import * as fromProductsOpenPlatformActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/products.op.actions';

export interface State extends EntityState<ProductOP> {
  selectedProductId: number | null;
  selectedContractId: number | null;
}

export const adapter: EntityAdapter<ProductOP> = createEntityAdapter<ProductOP>({
  selectId: (_product: ProductOP) => _product.productXId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedProductId: null,
  selectedContractId: null,
});

export function reducer(state = initialState, action: fromProductsOpenPlatformActions.Actions): State {
  switch (action.type) {
    case fromProductsOpenPlatformActions.ActionTypes.FETCH_SUCCESS: {
      const payload: ProductsResponseOP = action.payload;
      const products = payload.products;
      return adapter.addMany(products, adapter.removeAll(state));
    }
    case fromProductsOpenPlatformActions.ActionTypes.SELECT_PRODUCT: {
      return { ...state, selectedProductId: action.payload }; // resetear todo el estado
    }
    case fromProductsOpenPlatformActions.ActionTypes.UPDATE_PRODUCT: {
      const payload: ProductOP = action.payload;
      return adapter.updateOne({ id: payload.productXId, changes: payload }, state);
    }
    case fromProductsOpenPlatformActions.ActionTypes.SELECT_CONTRACT: {
      return { ...state, selectedContractId: action.payload };
    }
    case fromProductsOpenPlatformActions.ActionTypes.FETCH:
    case fromProductsOpenPlatformActions.ActionTypes.FETCH_FAILURE:
    default:
      return state;
  }
}
